"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const i18next_1 = __importDefault(require("i18next"));
function default_1(user, withoutMiddleName = false) {
  if (!user) return '';
  let {
    firstName,
    lastName,
    middleName,
    type,
    avatarDisplayName
  } = user;
  if (avatarDisplayName) {
    return avatarDisplayName || '';
  } else {
    return '######';
  }
  if (type === 'legal') return firstName;
  if (withoutMiddleName) {
    return [lastName || i18next_1.default.t('components.appSearch.unknown'), firstName || (lastName ? '' : i18next_1.default.t('components.appSearch.resident').toLowerCase())].filter(Boolean).join(' ');
  }
  return [lastName, firstName, middleName].filter(Boolean).join(' ');
}
exports.default = default_1;